// Story 8.10 (ADO-2019): the HHT pills (the 8.10 Figma properties): 20px high, radius
// 9999, padding 0 8px, Inter 400 12/16, an optional 6px dot. Local rather than the DS
// StatusBadge, whose 600 weight, 2px 10px padding and info text tone the other screens
// rely on. The tone is always carried by the visible label, never by colour alone.
import type { ReactNode } from 'react';
import styles from './HhtOrders.module.css';

export type HhtPillTone =
  | 'warning'
  | 'success'
  | 'info'
  | 'error'
  | 'errorCount'
  | 'neutral'
  | 'outline';

export function HhtPill({
  tone,
  dot = false,
  children,
}: {
  readonly tone: HhtPillTone;
  readonly dot?: boolean;
  readonly children: ReactNode;
}) {
  return (
    <span className={styles.pill} data-tone={tone}>
      {dot ? <span className={styles.pillDot} aria-hidden /> : null}
      {children}
    </span>
  );
}
